module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAzQAAAAUCAYAAABbNnjcAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATpJREFUeNrs3WFLAjEAgOHdzqg+BHH//49G2Tpplh6XrrJ1O58HhoeCbKegLzuxSykFAACAFkWnAAAAEDQAAACCBgAAQNAAAACCBgAAQNAAAAAIGgAAgJ3NqQe7rvs4zGN6DAAAcGkpj6Pjuf/Q3BQ8WcwBEydD1AAAAH8RM6+Tsb/v20Gz343pxxp6WvzKZ4rtql75Fa2/5bW0MvcW5rnkOS51bkucl3PlfW+O6/mcW9t3rWv+7tjC2odheBxvnsfxMo5t7pL0k6CJoWwnBwAA4FLuw+dVYSkcX4ZWHDQhB82N8wkAAFT0cBAz2zxmY+UUOzQAAMB/2O3Q3OYW+fI3/KVB0zufAABARXfh/Uqx/jdBcxg1AAAAtZyNmdKgAQAAqC2W9IqgAQAAmq4eAAAAQQMAAFDTmwADAMd8UpUlw6WNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/bg_document_top.png
// module id = 685
// module chunks = 51